import React from 'react'

import { notification } from 'antd'

export const openNotificationWithIcon = (type, message, description = '') => {
  notification[type]({
    message: message ? message : 'Notification Title',
    description: description,
  })
}
